function Subtitle({children}:any) {
  return (
    <div className="text-luminode-blue uppercase text-[18px] font-glass font-medium tracking-tighter leading-tight">
      {children}
    </div>
  );
}

export default Subtitle;